import React from "react";
import classNames from "classnames";
import BusComponent from "../BusComponent";
import { injectIntl } from "react-intl";
import Tooltip from "../Tooltip";

class MapLayersPanelHeader extends BusComponent {
    constructor(props, context) {
        super(props, context)
    }

    render() {
        const { onClose, onAddLayersClick, onDataUploadClick, intl, isUserStarterTier } = this.props;

        return (
            <div className="map-layers-panel__popup__container__header">
                <span> {intl.formatMessage({id: "dataBrowser.mapLayers"})} </span>
                <div className="map-layers-panel__popup__container__header action-buttons-container">
                    <Tooltip
                        placement="bottom"
                        mouseEnterDelay={0.5}
                        mouseLeaveDelay={0}
                        overlay={intl.formatMessage({
                            id: isUserStarterTier ? 'starterTier.upgradeToPro' : 'dataBrowser.addLayers',
                        })}
                    >
                        <button
                            className={classNames("map-layers-panel__popup__container__header action-buttons-container action-button", {
                                'disabled-button': isUserStarterTier
                            })}
                            onClick={onAddLayersClick}
                            disabled={isUserStarterTier}
                        >
                            <i className="material-icons-outlined"> local_library </i>
                        </button>
                    </Tooltip>
                    <Tooltip
                        placement="bottom"
                        mouseEnterDelay={0.5}
                        mouseLeaveDelay={0}
                        overlay={intl.formatMessage({
                            id: isUserStarterTier ? 'starterTier.upgradeToPro' : 'dataBrowser.uploadData',
                        })}
                    >
                        <button
                            className={classNames("map-layers-panel__popup__container__header action-buttons-container action-button", {
                               'disabled-button': isUserStarterTier
                            })}
                            onClick={onDataUploadClick}
                            disabled={isUserStarterTier}
                        >
                            <i className="material-icons-outlined"> cloud_upload </i>
                        </button>
                    </Tooltip>
                    <div className="map-layers-panel__popup__vertical-divider"/>
                    <Tooltip
                        placement="bottom"
                        mouseEnterDelay={0.5}
                        mouseLeaveDelay={0}
                        overlay={intl.formatMessage({
                            id: 'dataBrowser.minimize',
                        })}
                    >
                        <button
                            className="map-layers-panel__popup__container__header action-buttons-container minimize-button"
                            onClick={onClose}
                        >
                            <i className="material-icons"> keyboard_double_arrow_down </i>
                        </button>
                    </Tooltip>
                </div>
            </div>
        );
    }
}

export default injectIntl(MapLayersPanelHeader);
